export default __webpack_public_path__ + "static/media/Figure-10.c92e5291.jpg";